import React, { useRef } from 'react';
import { TAX_DOC_ACCEPT } from '../utils/security';

// Upload field for the supplier's vergi levhası (PDF / JPG / PNG, max 5 MB).
// The file is only ever visible to the platform admin.
export default function TaxDocumentInput({ file, onChange, accent = 'purple' }) {
  const ref = useRef(null);
  const ring = accent === 'purple' ? 'hover:border-purple-400' : 'hover:border-blue-400';
  const sizeKb = file ? Math.max(1, Math.round(file.size / 1024)) : 0;

  return (
    <div>
      <input ref={ref} type="file" accept={TAX_DOC_ACCEPT} className="hidden"
        onChange={e => { onChange(e.target.files?.[0] || null); e.target.value = ''; }} />
      <button type="button" onClick={() => ref.current?.click()}
        className={`w-full flex items-center gap-3 px-3 py-3 border-2 border-dashed rounded-lg text-sm text-left transition
          ${file ? 'border-green-300 bg-green-50' : `border-gray-200 ${ring}`}`}>
        <span className="text-lg">{file ? '📄' : '⬆️'}</span>
        <span className="flex-1 min-w-0">
          {file ? (
            <>
              <span className="block font-semibold text-gray-800 truncate">{file.name}</span>
              <span className="block text-xs text-gray-500">{sizeKb.toLocaleString('tr-TR')} KB · değiştirmek için tıklayın</span>
            </>
          ) : (
            <>
              <span className="block font-semibold text-gray-700">Vergi levhası yükle</span>
              <span className="block text-xs text-gray-400">PDF, JPG veya PNG · en fazla 5 MB</span>
            </>
          )}
        </span>
      </button>
      <p className="text-xs text-gray-400 mt-1.5">
        🔒 Belgeniz yalnızca doğrulama için kullanılır; herkese açık değildir.
      </p>
    </div>
  );
}
